// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"_1zgHlGiSPYUTpqQEyeoTJH","breadcrumbItem":"aFv6vBXmKKh40FWeaciEf","breadcrumbItemActive":"_22BHEBOqFMJc2UGnOW5Hyp"};